import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';

const Verification: React.FC = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [timer, setTimer] = useState(180); // 3분 = 180초

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setCode(value);
  };

  const handleResend = () => {
    setTimer(180);
    setCode('');
  };

  const handleNext = () => {
    if (code.length >= 4) {
      navigate('/signup/gender');
    }
  };

  const handleBack = () => {
    navigate('/signup/phone');
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                받으신 인증번호를
                <br />
                입력해 주세요.
              </h1>
              <p className="signup-subtitle">
                문자로 인증번호를 발송하였습니다.
              </p>
            </div>

            <div className="input-section">
              <div className="verification-input-wrapper">
                <input
                  type="tel"
                  className="signup-input verification-input"
                  placeholder=""
                  value={code}
                  onChange={handleCodeChange}
                  maxLength={6}
                />
                <span className="timer">{formatTime(timer)}</span>
              </div>
              <button className="resend-btn" onClick={handleResend}>
                인증번호 재발송
              </button>
            </div>
          </div>

          <div className="signup-footer">
            <div className="terms-text">
              <p>
                '인증번호 확인' 버튼을 누름으로써{' '}
                <span className="link-text-inline">
                  이용약관, 개인정보취급방침
                  <br />및 위치기반서비스 이용약관
                </span>
                에 동의하는 것으로 간주합니다.
              </p>
            </div>

            <button
              className={`signup-btn ${code.length >= 4 ? 'active' : ''}`}
              onClick={handleNext}
              disabled={code.length < 4}
            >
              인증번호 확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verification;
